document.addEventListener('DOMContentLoaded', function () {
	console.log('!!!!!!!'); // Initialize variables and DOM elements
	let productId = '';
	const productIdInput = document.getElementById('product_id');
	const variationIdElem = document.getElementById('variation_id');
	const lengthArea = document.getElementById('length-area');
	const unitsArea = document.getElementById('units-area');
	const addToCartButton = document.getElementById('addToCartButton');
	const addToQuoteButton = document.getElementById('requestQuoteButton');
	const gradeInput = document.getElementById('grade_id');
	const gradeSelect = document.getElementById('grade');
	const attributeSelects = document.querySelectorAll('.attribute-dropdown');
	const attributeSelectIds = Array.from(attributeSelects).map((select) =>
		select.getAttribute('id')
	);
	let numOfSelects = attributeSelects.length - 1;
	let attributeNames = '';

	const widthInput = document.getElementById('width');
	const units2Area = document.getElementById('units2-area');
	const widthArea = document.getElementById('width-area');

	const lengthInput = document.getElementById('length');
	const unitsSelect = document.getElementById('units');
	const unitsInput = document.getElementById('units_id');
	const unitsSelect2 = document.getElementById('units2');
	const unitsInput2 = document.getElementById('units2_id');

	const quoteCountElement = document.getElementById('quote-count');
	const quoteCountDisplay = document.querySelectorAll('.quote-item-count');
	const materialSpec = document.querySelector('#product-specs p');
	const weightUS = document.querySelector('#product-weight .us');
	const weightUK = document.querySelector('#product-weight .uk');
	const gradeName = document.getElementById('gradeName');

	const equiv = document.getElementById('equiv');
	const chemistry = document.querySelector('#chemistry .collapse-content');
	const mechanical = document.querySelector('#mechanical .collapse-content');
	const tolerance = document.querySelector('#tolerance .collapse-content');
	const materialCert = document.getElementById('material_cert');
	const quoteDrawer = document.getElementById('quote-drawer');
	const productDetails = document.getElementById('productDetails');

	const utils = {
		isEmptyInput: (input) => !input.value || input.value.trim() === '',
		isStockLength: (input) => input.placeholder === 'Stock Length',
		convertToFeet: (value, unit) => {
			if (unit === 'stock-length') return 0;
			return parseFloat(value) * conversions[unit];
		},
		removeError: (element) => {
			if (element.classList.contains('error')) {
				element.classList.remove('error');
			}
		},
	};

	// Select2 initialization and event handling
	if (document.querySelector('.account-select')) {
		jQuery('.account-select').select2({
			minimumResultsForSearch: Infinity,
		});
	}
	if (document.querySelector('.select')) {
		jQuery('.select')
			.select2({
				minimumResultsForSearch: 200,
			})
			.on('select2:open', function () {
				var thisSelect = jQuery(this);
				setTimeout(function () {
					var dropdown = jQuery(
						'.select2-container--open .select2-dropdown'
					);
					var resultsContainer = dropdown.find(
						'.select2-results__options'
					);
					var selectOffset = thisSelect.offset();
					var selectHeight = thisSelect.outerHeight();
					var windowHeight = jQuery(window).height();
					var scrollTop = jQuery(window).scrollTop();
					var dropdownHeight = dropdown.outerHeight();

					var spaceAbove = selectOffset.top - scrollTop;
					var spaceBelow =
						windowHeight -
						(selectOffset.top - scrollTop + selectHeight);

					var maxHeight;
					var isDropUp = dropdown.hasClass('select2-dropdown--above');

					if (isDropUp) {
						maxHeight = spaceAbove - 20; // 20px buffer
					} else {
						maxHeight = spaceBelow - 20; // 20px buffer
					}

					resultsContainer.css({
						'max-height': maxHeight + 'px',
					});
				}, 0);
			})

			.on('select2:select', function (e) {
				var thisSelect = jQuery(this);
				var parent = thisSelect.parent('[data-select-container]');
				var value = e.params.data.id;
				var selectId = jQuery(this).attr('id');
				var dataAttributeName = jQuery(this).data('attribute_name');
				/*console.log(
					'1 selectChange ',
					selectId,
					' : ',
					value,
					' attr',
					dataAttributeName
				);*/

				var selectId = jQuery(this).attr('id');
				//console.log('lkljlkjlkj ', selectId, ' value ', value);
				if (selectId == 'units' && value == 'stock-length') {
					//console.log('gotta update length placeholder');
					lengthInput.value = '';
					lengthInput.placeholder = 'Stock Length';
					removeLengthNotice();
					//console.log('unit stock enableBtn');
					enableAddToQuoteButton();
				} else if (selectId == 'units') {
					if (
						lengthInput.value &&
						widthInput &&
						widthInput.value &&
						unitsInput2 &&
						unitsInput2.value
					) {
						//console.log('checkV 5');
						checkValid(
							lengthInput.value,
							value,
							widthInput.value,
							unitsInput2.value
						);
					} else if (lengthInput.value) {
						if (unitsInput2 === 'stock-length') {
							//console.log('checkV 6');
							checkValid(
								lengthInput.value,
								value,
								widthInput.value,
								unitsInput2.value
							);
						} else {
							//console.log('checkV 66');
							checkValid(lengthInput.value, value);
						}
					}
				}

				document.getElementById(
					dataAttributeName + '_id'
				).value = value;
				if (
					document.getElementById(dataAttributeName + '_id').value !=
					null
				) {
					const selectRendered = parent.find(
						'.select2-selection__rendered'
					);
					const borderHolder = parent.find(
						'.select2-container--default .select2-selection--single'
					);
					selectRendered.removeClass('error');
					borderHolder.removeClass('error');
				}
				if (dataAttributeName == 'grade') {
					//console.log('GRADE&&&&&&&&&');
					productId = e.params.data.element.dataset.productid;
					document.getElementById('product_id').value = productId;
					weightUS.innerHTML = 'Select a size (lbs/foot)';
					weightUK.innerHTML = 'Select a size (kg/m)';

					// reset attribute selects and clear URL parameters
					const url = new URL(window.location);
					attributeSelects.forEach((select, index) => {
						const selectElement = jQuery(select);
						const inputId = select.id.replace('attribute_id-', '');
						document.getElementById(inputId + '_id').value = '';
						url.searchParams.delete(inputId);
						selectElement.val('').trigger('change');

						// Disable all attribute selects
						selectElement.prop('disabled', true);
						const label = document.querySelector(
							`label[for="${select.id}"]`
						);
						if (label) {
							label.classList.add('disabled');
						}

						// Clear the window property for this attribute
						delete window['attribute_id-' + inputId];
					});

					//console.log('selectedAttributes ', selectedAttributes);
					Object.keys(selectedAttributes).forEach(
						(key) => delete selectedAttributes[key]
					);
					//console.log('selectedAttributes2 ', selectedAttributes);

					// Update the URL before fetching product details
					url.searchParams.set('grade', value);
					window.history.pushState({}, '', url);

					fetchProductDetails(productId, attributeSelectIds[0]);
					disableAddToQuoteButton();
				} else if (selectId.startsWith('attribute')) {
					selectedAttributes[dataAttributeName] = value;
					const selectIndex = jQuery(this).data('index');
					//console.log('selectIndex ', selectIndex);
					// Clear all subsequent attributes
					for (
						let i = selectIndex;
						i < attributeSelects.length;
						i++
					) {
						const subsequentSelect = jQuery(attributeSelects[i]);
						const subsequentInputId = attributeSelects[
							i
						].id.replace('attribute_id-', '');
						document.getElementById(
							subsequentInputId + '_id'
						).value = '';

						subsequentSelect.val('').trigger('change');
						subsequentSelect.prop('disabled', true);
						/*console.log(
							'clear and disable ',
							subsequentInputId + '_id'
						);*/
						const url = new URL(window.location);
						url.searchParams.delete(subsequentInputId);
						window.history.pushState({}, '', url);

						disableAddToQuoteButton();
						const label = document.querySelector(
							`label[for="${attributeSelects[i].id}"]`
						);
						if (label) {
							label.classList.add('disabled');
						}
						delete selectedAttributes[
							attributeSelects[i].dataset.attribute_name
						];
					}

					updateVariationId(
						productIdInput.value,
						numOfSelects,
						selectIndex
					);
					// Update URL
					const url = new URL(window.location);
					url.searchParams.set(dataAttributeName, value);
					window.history.pushState({}, '', url);
				} else {
					const url = new URL(window.location);
					url.searchParams.set(selectId, value);
					window.history.pushState({}, '', url);
					window[selectId] = value;
					//console.log('enable 2');
					enableAddToQuoteButton();
				}

				if (selectId == 'units2') {
					//console.log('units2 input being set with ', value);
					unitsInput2.value = value;
					if (value == 'stock-length') {
						//console.log('update stock width place');
						widthInput.value = '';
						widthInput.placeholder = 'Stock Width';

						if (lengthInput.value && unitsInput.value) {
							//console.log('checkV 7');
							checkValid(
								lengthInput.value,
								unitsInput.value,
								widthInput.value,
								value
							);
						}
					} else {
						if (widthInput.value) {
							validateWidth(widthInput.value, value);
						}
					}
					const url = new URL(window.location);
					url.searchParams.set(selectId, value);
					window.history.pushState({}, '', url);
					window[selectId] = value;
					//console.log('enable 3');
					enableAddToQuoteButton();
				}
			});
	}

	function validateWidth(width, units2) {
		if (!width || !units2 || units2 == 'stock-length') return true;
		const widthInFeet = parseFloat(width) * conversions[units2];
		if (widthInFeet > 10) {
			showLengthNotice('plate');
			disableAddToQuoteButton();
			return false;
		} else {
			removeLengthNotice();
			enableAddToQuoteButton();
			return true;
		}
	}

	function handleDimensionChange(event) {
		const input = event.target;
		const value = parseFloat(input.value);
		const isLength = input.id === 'length';
		const isWidth = input.id === 'width';

		//console.log(`${input.id} changed to:`, value);

		// Remove error class if value is valid
		if (value > 0 && input.classList.contains('error')) {
			input.classList.remove('error');
		}

		// Update URL with new value
		const url = new URL(window.location);
		if (value) {
			url.searchParams.set(input.id, input.value);
			window.history.pushState({}, '', url);
		}
		if (isWidth) {
			if (value && unitsInput2 && unitsInput2.value) {
				validateWidth(value, unitsInput2.value);
			}
			enableAddToQuoteButton();
		}
		// Handle dimension validation
		if (isLength) {
			if (
				widthInput &&
				unitsInput2 &&
				unitsInput2.value &&
				lengthInput.value
			) {
				//console.log('checkV: length with width');
				//console.log('units area 4');
				unitsArea.classList.remove('disabled');
				checkValid(
					value,
					unitsInput.value,
					widthInput.value,
					unitsInput2.value
				);
			} else if (unitsInput.value) {
				//console.log('checkV: length only');
				checkValid(value, unitsInput.value);
			}
		} else if (isWidth) {
			if (value) {
				if (unitsInput2.value) {
					//console.log('checkV: width with units2');
					checkValid(
						lengthInput.value,
						unitsInput.value,
						value,
						unitsInput2.value
					);
				}
				//console.log('enable: width changed');
				enableAddToQuoteButton();
			}
		}
	}

	// Function to handle arrow key interactions
	function handleArrowKeys(event) {
		if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
			//console.log(`Arrow ${event.key} pressed on ${event.target.id}`);
			// The value change will be caught by the input/change events
		}
	}

	// Function to initialize dimension input handlers
	function initializeDimensionInputs() {
		const inputs = [
			document.getElementById('length'),
			document.getElementById('width'),
		].filter(Boolean); // Filter out null if width doesn't exist

		inputs.forEach((input) => {
			// Add event listeners for both input and change events
			input.addEventListener('input', handleDimensionChange);
			input.addEventListener('change', handleDimensionChange);
			input.addEventListener('keydown', handleArrowKeys);

			// Initialize URL parameters if they exist
			const urlParams = new URLSearchParams(window.location.search);
			const paramValue = urlParams.get(input.id);
			if (paramValue) {
				input.value = paramValue;
				input.dispatchEvent(new Event('change'));
			}
		});
	}

	initializeDimensionInputs();

	// Function to fetch product details
	async function fetchProductDetails(productId, elForLoading) {
		disableSpecs();
		showSpinner(elForLoading);
		//console.log('productId ', productId, ' eltoLoad ', elForLoading);
		try {
			const response = await fetch(quote_params.ajax_url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams({
					action: 'fetch_product_details',
					product_id: productId,
				}),
			});

			if (response.ok) {
				const data = await response.json();
				//console.log('data ', data.data);
				if (data.success === true) {
					gradeName.innerHTML = data.data.name;
					attributeNames = data.data.attribute_names;
					productDetails.classList.remove('disabled');

					if (data.data && data.data.image_url) {
						const prodImage = document.getElementById(
							'product-image'
						);
						if (prodImage) {
							prodImage.src = data.data.image_url;
						}
					}
					populateGradeAndEquivalents(
						data.data.equivalents,
						data.data.gradeToolTip,
						data.data.grade
					);

					populateAttributeSelect(
						attributeSelects[0],
						data.data.attributes[0],
						productId
					);
					hideSpinner(elForLoading);

					enableSpecs(
						data.data.specs,
						data.data.chemistry,
						data.data.mechanical,
						data.data.tolerance
					);

					if (window.initialAttr) {
						document
							.querySelectorAll('.attribute-dropdown')
							.forEach(function (dropdown) {
								dropdown.value = window.initialAttrValue;
								dropdown.dispatchEvent(new Event('change'));
							});
					}
				} else {
					showError('Failed to load product details.');
				}
			} else {
				showError('Failed to load product details.');
			}
		} catch (error) {
			hideSpinner();
			showError('Failed to load product details.');
		}
	}

	function disableSpecs() {
		materialSpec.innerHTML = 'Select a grade';
		[chemistry, mechanical, tolerance, equiv].forEach((element) => {
			element.innerHTML = '';
			let collapseParent = element.closest('.collapse');
			let checkbox = collapseParent.querySelector(
				'input[type="checkbox"]'
			);
			if (checkbox) {
				checkbox.checked = false;
			}
			if (checkbox && !checkbox.disabled) {
				checkbox.disabled = true;
			}
		});
	}

	function enableSpecs(specs, chem, mech, tol) {
		if (
			specs &&
			(typeof specs === 'string'
				? specs.trim() !== ''
				: Object.keys(specs).length !== 0)
		) {
			materialSpec.innerHTML = specs;
		}

		if (chem && Object.keys(chem).length !== 0) {
			let chemistryTable = Object.entries(chem)
				.filter(([key, value]) => value)
				.map(([key, value]) => {
					if (key === 'chemtext') {
						return `${value}`;
					} else {
						return `<strong style="text-transform:uppercase;min-width:40px;display:inline-block;">${key}</strong> ${value}`;
					}
				})
				.join('<br/>');
			if (chemistryTable) {
				chemistry.innerHTML = chemistryTable;
				enableCheckbox(chemistry);
			}
		}
		if (
			mech &&
			(typeof mech === 'string'
				? mech.trim() !== ''
				: Object.keys(mech).length !== 0)
		) {
			let mechanicalTable = Object.entries(mech)
				.filter(([key, value]) => value) // Filter out falsy values
				.map(([key, value]) => {
					// Modify the key for 'reductionarea' and handle 'textarea'
					if (key === 'textarea') {
						return `${value}`; // Display value without key
					}
					const displayKey =
						key === 'reductionarea' ? 'reduction area' : key;
					return `<strong style="text-transform:uppercase; min-width:120px;display:inline-block;">${displayKey}</strong> ${value}`;
				})
				.join('<br/>');

			if (mechanicalTable) {
				mechanical.innerHTML = mechanicalTable;
				enableCheckbox(mechanical);
			}
		}
		if (tol) {
			tolerance.innerHTML = tol;
			enableCheckbox(tolerance);
		} else {
			tolerance.innerHTML =
				'Please call the sales department at <a href="tel:18003334140">1-800-333-4140</a> for tolerance information.';
			enableCheckbox(tolerance);
		}
	}

	function enableCheckbox(element) {
		const collapseParent = element.closest('.collapse');
		const radioButton = collapseParent.querySelector(
			'input[type="checkbox"]'
		);
		if (radioButton) {
			radioButton.disabled = false;
		}
	}

	function disableCheckbox(element) {
		//console.log('disable me ', element);
		const collapseParent = element.closest('.collapse');
		const check = collapseParent.querySelector('input[type="checkbox"]');
		if (check) {
			check.disabled = true;
			check.checked = false;
		}
	}

	// Functions to show/hide spinner
	function showSpinner(elForLoading) {
		const loadingIcon = document.querySelector(
			`[data-name="${elForLoading}"]`
		);
		if (loadingIcon) {
			loadingIcon.classList.remove('hidden');
		} else {
			//console.warn('No loading icon found for', elForLoading);
		}
	}

	function hideSpinner(elForLoading) {
		const loadingIcon = document.querySelector(
			`[data-name="${elForLoading}"]`
		);
		if (loadingIcon) {
			loadingIcon.classList.add('hidden');
		}
	}

	function formatNumber(num) {
		return num.toFixed(3).replace(/\.?0+$/, '');
	}

	const conversions = {
		feet: 1,
		meters: 3.28084,
		millimeters: 0.00328084,
		inches: 1 / 12,
	};

	function checkValid(length, unit, width = null, unit2 = null) {
		//console.log('Validating:', { length, unit, width, unit2 });

		// Early check if this is a length-only product
		const hasWidthFields = widthInput && unitsInput2;

		const updateUI = (isValid, noticeType = null) => {
			addToQuoteButton.disabled = !isValid;
			addToQuoteButton.classList.toggle('disabled', !isValid);
			if (isValid) {
				removeLengthNotice();
				removeWooNotice();
			} else if (noticeType) {
				showLengthNotice(noticeType);
			}
			return isValid;
		};

		const isStockDimension = (unit) => unit === 'stock-length';

		// Validate that required units are present
		const areUnitsValid = () => {
			if (!unit) return false;
			if (hasWidthFields && width !== null && !unit2) return false;
			return true;
		};

		// Early return if required units are missing
		if (!areUnitsValid()) {
			return updateUI(false);
		}

		const handleStockDimension = (input, placeholder) => {
			if (input) {
				input.value = '';
				input.placeholder = placeholder;
			}
		};

		const checkDimension = (size, unit) => {
			if (isStockDimension(unit)) return true;
			return parseFloat(size) * conversions[unit] <= 20;
		};

		// Handle length-only products
		if (!hasWidthFields) {
			if (isStockDimension(unit)) {
				handleStockDimension(lengthInput, 'Stock Length');
				return updateUI(true);
			}
			return updateUI(checkDimension(length, unit), 'default');
		}

		// Handle width-based products
		// Both stock dimensions
		if (unit === 'stock-length' && unit2 === 'stock-length') {
			handleStockDimension(lengthInput, 'Stock Length');
			handleStockDimension(widthInput, 'Stock Width');
			return updateUI(true);
		}

		// Length is stock
		if (unit === 'stock-length') {
			handleStockDimension(lengthInput, 'Stock Length');
			if (!width && unit2 === 'stock-length') {
				return updateUI(true);
			}
			return updateUI(checkDimension(width, unit2), 'default');
		}

		// Width is stock but length isn't
		if (unit2 === 'stock-length') {
			handleStockDimension(widthInput, 'Stock Width');
			if (!length && unit === 'stock-length') {
				return updateUI(true);
			}
			const isValid = checkDimension(length, unit);
			return updateUI(isValid, 'default');
		}

		// Neither dimension is stock
		if (!length || !width) {
			return updateUI(false);
		}
		const lengthInFeet = parseFloat(length) * conversions[unit];
		const widthInFeet = parseFloat(width) * conversions[unit2];

		const isValid = !(
			(lengthInFeet > 10 || widthInFeet > 8) &&
			(lengthInFeet > 8 || widthInFeet > 10)
		);
		return updateUI(isValid, 'plate');
	}

	function enableAddToQuoteButton() {
		if (!addToQuoteButton) return;

		const hasWidthFields = widthInput && unitsInput2;

		// Handle plate/sheet products
		if (hasWidthFields) {
			/*console.log(
				'l:',
				lengthInput.value,
				'u:',
				unitsInput.value,
				'w:',
				widthInput.value,
				'u2:',
				unitsInput2.value
			);
			*/
			// If either dimension is stock-length, treat empty value as valid
			const isLengthValid =
				unitsInput.value === 'stock-length' || lengthInput.value;
			const isWidthValid =
				unitsInput2.value === 'stock-length' || widthInput.value;
			const hasRequiredUnits = unitsInput.value && unitsInput2.value;

			if (!widthInput.value && !unitsInput2.value) {
				widthArea.classList.remove('disabled');
				return;
			}

			if (widthInput.value || unitsInput2.value === 'stock-length') {
				if (units2Area.classList.contains('disabled')) {
					units2Area.classList.remove('disabled');
					return;
				}
			}

			if (
				widthInput.value &&
				unitsInput2.value &&
				lengthArea.classList.contains('disabled')
			) {
				//console.log('lA 2');
				lengthArea.classList.remove('disabled');
				return;
			}

			// Final validation for plate/sheet
			if (isWidthValid && isLengthValid && hasRequiredUnits) {
				//console.log('checkV 1');
				checkValid(
					lengthInput.value,
					unitsInput.value,
					widthInput.value,
					unitsInput2.value
				);
			}
		} else {
			// Handle length-only products
			const isLengthValid =
				unitsInput.value === 'stock-length' || lengthInput.value;
			const hasRequiredUnits = unitsInput.value;

			if (lengthInput.value && unitsArea.classList.contains('disabled')) {
				unitsArea.classList.remove('disabled');
			}

			// Check validity based on product type
			if (!isLengthValid && !utils.isStockLength(lengthInput)) {
				//console.log('show l');
				lengthArea.classList.remove('disabled');
				return;
			}

			// Final validation for length-only products
			if (isLengthValid && hasRequiredUnits) {
				//console.log('checkV 2');
				checkValid(lengthInput.value, unitsInput.value);
			} else if (utils.isStockLength(lengthInput)) {
				unitsArea.classList.remove('disabled');
			}
		}
	}
	function disableAddToQuoteButton() {
		if (addToQuoteButton) {
			addToQuoteButton.classList.add('disabled');
			addToQuoteButton.disabled = true;
		}
	}

	const quoteSubmitWrapper = document.getElementById('quoteSubmitWrapper');

	function removeWooNotice() {
		//console.log('remove Woo');
		const errorMsg = document.querySelector('.error-display-woo');
		if (errorMsg) {
			errorMsg.remove();
		}
	}
	function showWooCommerceNotice() {
		// Scroll to the notice
		//console.log('show WooN');
		document
			.getElementById('top')
			.scrollIntoView({ behavior: 'smooth', block: 'center' });
		const errorMsg = document.querySelector('.error-display-woo');
		if (!errorMsg) {
			var el = document.createElement('div');
			el.classList.add(
				'error-display',
				'error-display-woo',
				'text-metric-error',
				'mr-4',
				'mt-2',
				'length-error'
			);
			el.appendChild(
				document.createTextNode('*These fields are required')
			);
			quoteSubmitWrapper.prepend(el);
		}
	}
	function removeLengthNotice() {
		//console.log('remove L');
		const errorMsg = document.querySelector('.error-display-woo');
		if (errorMsg) {
			errorMsg.remove();
		}
		const errorDisplay = document.querySelector(
			'.error-display-length.text-metric-error'
		);
		if (errorDisplay) {
			errorDisplay.remove();
		}
	}

	function showLengthNotice(type = 'default') {
		//console.log('show LengthNotice');
		// Scroll to the notice

		document
			.getElementById('requestQuoteButton')
			.scrollIntoView({ behavior: 'smooth', block: 'center' });
		const errorMsg = document.querySelector('.error-display-length');
		if (!errorMsg) {
			var el = document.createElement('div');
			el.classList.add(
				'error-display',
				'error-display-length',
				'text-metric-error',
				'mr-4',
				'length-error'
			);
			if (type === 'default') {
				const text =
					'For lengths of material longer than the equivalent of 20 feet, please contact our sales department at tel:8003334140,800-333-4140 or mailto:sales@metricmetal.com for a quote on this special order item.';
				el.innerHTML =
					'For lengths of material longer than the equivalent of 20 feet, please contact our sales department at <a class="underline" href="tel:8003334140">800-333-4140</a> or <a class="underline" href="mailto:sales@metricmetal.com">sales@metricmetal.com</a> for a quote on this special order item.';

				quoteSubmitWrapper.prepend(el);
				disableAddToQuoteButton();
			} else {
				const text =
					'For lengths of material longer than the equivalent of 20 feet, please contact our sales department at tel:8003334140,800-333-4140 or mailto:sales@metricmetal.com for a quote on this special order item.';

				el.innerHTML =
					'Plate and Sheet products max width and length must be the equivalent of 96" x 120". Please contact our sales department at <a class="underline" href="tel:8003334140">800-333-4140</a> or <a class="underline" href="mailto:sales@metricmetal.com">sales@metricmetal.com</a> for a quote on this special order item.';

				quoteSubmitWrapper.prepend(el);
				disableAddToQuoteButton();
			}
			//el.appendChild();
			//quoteSubmitWrapper.prepend(nodeWithLinks);
		}
	}

	if (quoteSubmitWrapper) {
		quoteSubmitWrapper.addEventListener('click', function (e) {
			let errors = 0;
			// Check if grade is selected
			const gradeSelect = document.getElementById('grade');
			if (!gradeSelect.value) {
				errors++;
				//console.log('error: grade');
				const parent = gradeSelect.closest('[data-select-container]');
				const select = parent.querySelector(
					'.select2-selection__rendered'
				);
				const borderHolder = parent.querySelector(
					'.select2-container--default .select2-selection--single'
				);
				select.classList.add('error');
				borderHolder.classList.add('error');
			}

			// Check if all enabled attribute selects have a value
			attributeSelectIds.forEach((select) => {
				let thisInput = select.replace('attribute_id-', '');
				thisInput = thisInput.concat('_id');
				//console.log('thisInput ', thisInput);
				if (!document.getElementById(thisInput).value) {
					errors++;
					//console.log('error attr');
					const parent = document
						.getElementById(thisInput)
						.closest('[data-select-container]');
					const selector = parent.querySelector(
						'.select2-selection__rendered'
					);
					const borderHolder = parent.querySelector(
						'.select2-container--default .select2-selection--single'
					);

					selector.classList.add('error');
					borderHolder.classList.add('error');
				}
			});

			if (widthInput) {
				if (!widthInput.value) {
					if (widthInput.placeholder == 'Stock Width') {
					} else {
						widthInput.classList.add('error');
						//console.log('error width');
						errors++;
					}
				}
			}
			if (unitsInput2) {
				if (!unitsInput2.value) {
					errors++;
					//console.log('error units2');
					const parent = unitsInput2.closest(
						'[data-select-container]'
					);
					const select = parent.querySelector(
						'.select2-selection__rendered'
					);
					const borderHolder = parent.querySelector(
						'.select2-container--default .select2-selection--single'
					);
					select.classList.add('error');
					borderHolder.classList.add('error');
				}
			}

			// Check if length is entered
			if (!lengthInput.value) {
				if (lengthInput.placeholder == 'Stock Length') {
				} else {
					//console.log('error length');
					lengthInput.classList.add('error');
					errors++;
				}
			}

			// Check if units are selected

			if (!unitsInput.value) {
				errors++;
				//console.log('error units');
				const parent = unitsInput.closest('[data-select-container]');
				const select = parent.querySelector(
					'.select2-selection__rendered'
				);
				const borderHolder = parent.querySelector(
					'.select2-container--default .select2-selection--single'
				);
				select.classList.add('error');
				borderHolder.classList.add('error');
			}

			// Check if quantity is entered
			const quantityInput = document.getElementById('quantity');
			if (!quantityInput.value) {
				errors++;
				//console.log('error quantity');
				quantityInput.style.backgroundColor = 'rgba(255,59,48,0.05)';
				quantityInput.style.borderColor = '#FF3B30';
				quantityInput.style.borderWidth = '0.7px';
			}

			if (errors.length > 0) {
				//console.log('there are errors, show the text too');
				// Display errors using WooCommerce notice
				showWooCommerceNotice();
				e.preventDefault();
			} else if (addToQuoteButton.disabled) {
				//console.log('btn .disabled');
				showWooCommerceNotice();
				e.preventDefault();
			} else {
				if (document.querySelector('.error-display')) {
					document.querySelector('.error-display').remove();
				}
				// let default happen
			}
		});
	}

	// Object to hold selected attributes
	const selectedAttributes = {};
	// Function to update variation ID
	async function updateVariationId(productId, numOfSelects, attrIndex) {
		weightUS.innerHTML = 'Select a size (lbs/foot)';
		weightUK.innerHTML = 'Select a size (kg/m)';

		if (productId) {
			if (attributeNames[attrIndex]) {
				selectedAttributes[attributeNames[attrIndex]] = '';
			}
			await fetchVariations(productId, selectedAttributes, attrIndex);
		}
	}

	function processAttributes(attributes, index) {
		const keys = Object.keys(attributes);
		keys.forEach((key, i) => {
			if (i === index) {
				attributes[key] = '';
			} else if (i > index) {
				const selectToDisable = document.getElementById(
					'attribute_id-' + key
				);
				//console.log('disable attribute_id-' + key);
				//console.log('remove it from param too!');
				const emptyOption = Array.from(selectToDisable.options).find(
					(option) => option.value === ''
				);
				if (emptyOption) emptyOption.selected = true;

				var label = document.querySelector(
					'label[for="' + selectToDisable.id + '"]'
				);
				if (label) {
					label.classList.add('disabled');
				}
				selectToDisable.setAttribute('disabled', 'disabled');

				var firstOption = selectToDisable.querySelector(
					'option:first-of-type'
				);
				if (firstOption && firstOption.value === '') {
					selectToDisable.value = '';
				} else {
					selectToDisable.value = null;
				}
				selectToDisable.dispatchEvent(new Event('change'));
				window.jQuery(selectToDisable).trigger('change');

				disableAddToQuoteButton();

				delete attributes[key];
			}
		});
		return attributes;
	}

	function convertLbFtToKgM(weightInLbFt) {
		const lbToKg = 0.453592;
		const ftToM = 0.3048;
		const weightInKgM = weightInLbFt * (lbToKg / ftToM);
		return weightInKgM;
	}

	// Function to fetch variations
	async function fetchVariations(
		productId,
		selectedAttributes,
		attributeIndex
	) {
		const url = new URL(
			`/wp-json/custom/v1/product-variation`,
			quote_params.site_url
		);

		if (attributeIndex <= numOfSelects) {
			showSpinner(attributeSelectIds[attributeIndex]);
		}
		url.searchParams.append('product_id', productId);

		selectedAttributes = processAttributes(
			selectedAttributes,
			attributeIndex
		);
		/*console.log(
			'in fetchVariations. selectedAttributes ',
			selectedAttributes,
			' attributeIndex ',
			attributeIndex
		);*/
		Object.entries(selectedAttributes).forEach(([attr, value]) => {
			url.searchParams.append(attr, value);
			const urlParams = new URL(window.location);
			urlParams.searchParams.set(attr, value);
			window.history.pushState({}, '', urlParams);
		});

		try {
			const response = await fetch(url, {
				method: 'GET',
				/*headers: {
					Authorization: `Basic ${btoa(
						'ck_02c696ad2cec7b79e995a26e685afa830f21ec1c:cs_ef4ee616cfb321a40b0ec79df01af1d8ee678352'
					)}`,
				},*/
				headers: {
					'X-WP-Nonce': quote_params.restnonce,
				},
			});

			if (response.ok) {
				const data = await response.json();
				//console.log('data ', data);

				try {
					const variations = data.variations;
					const optionsForEmptyKey = data.options_for_empty_key;
					const emptyName = data.empty_name;

					if (
						optionsForEmptyKey &&
						Object.values(optionsForEmptyKey).length > 0
					) {
						//console.log('Entering optionsForEmptyKey block');
						let attributeSelect = document.getElementById(
							data.empty_key.replace(
								'attribute_',
								'attribute_id-'
							)
						);
						var attrInfo = {
							label: emptyName,
							name: data.empty_key,
							options: optionsForEmptyKey,
						};
						populateAttributeSelect(
							attributeSelect,
							attrInfo,
							productId
						);
						hideSpinner(attributeSelectIds[attributeIndex]);
						return;
					}

					if (variations.length === 1) {
						//console.log('1 variation ', variations);
						const variationId = variations[0].id;

						//console.log('show dem units');
						if (attributeIndex <= numOfSelects) {
							for (
								let x = attributeIndex + 1;
								x <= numOfSelects + 1;
								x++
							) {
								const select = document.querySelector(
									`.attribute-dropdown[data-index="${x}"]`
								);
								select.innerHTML += `<option value="${variations[0].attributes[attributeIndex].value}">${variations[0].attributes[attributeIndex].value}</option>`;
								select.removeAttribute('disabled');
							}
						}
						weightUS.innerHTML =
							Number(variations[0].description).toFixed(3) +
							' lbs/foot';

						let weightInKgM = convertLbFtToKgM(
							variations[0].description
						);
						weightUK.innerHTML =
							Number(weightInKgM).toFixed(3) + ' kg/m';

						if (variationId) {
							variationIdElem.value = variationId;
							unitsSelect.removeAttribute('disabled');
							// init
							const urlParams = new URLSearchParams(
								window.location.search
							);
							let widthParam = urlParams.get('width');
							let unitsParam = urlParams.get('units');
							let lengthParam = urlParams.get('length');
							let units2Param = urlParams.get('units2');

							/*console.log(
								'w ',
								widthParam,
								' u ',
								unitsParam,
								' l ',
								lengthParam,
								' u2 ',
								units2Param
							);*/
							if (urlParams.has('width')) {
								if (widthParam) {
									window['width'] = widthParam;
									widthInput.value = widthParam;
									widthArea.classList.remove('disabled');
								}
							}
							if (urlParams.has('units')) {
								if (unitsParam) {
									window['units'] = unitsParam;
									jQuery('#units')
										.val(unitsParam)
										.trigger('change');
									unitsInput.value = unitsParam;
									unitsArea.classList.remove('disabled');
								}
							}
							if (urlParams.has('length')) {
								if (lengthParam) {
									//console.log('la 3');
									lengthArea.classList.remove('disabled');
									lengthInput.value = lengthParam;
								}
							}
							if (urlParams.has('units2')) {
								if (units2Param) {
									window['units2'] = units2Param;
									jQuery('#units2')
										.val(units2Param)
										.trigger('change');
									units2Area.classList.remove('disabled');
									unitsInput2.value = units2Param;
								}
							}
							if (
								urlParams.has('grade') &&
								urlParams.has('width') &&
								urlParams.has('units2') &&
								urlParams.has('length') &&
								urlParams.has('units')
							) {
								/*console.log(
									'All URL parameters present, running final validation'
								);*/
								unitsArea.classList.remove('disabled');
								//console.log('checkV 3');
								checkValid(
									lengthParam,
									unitsParam,
									widthParam,
									units2Param
								);
							} else if (
								urlParams.has('grade') &&
								urlParams.has('length') &&
								urlParams.has('units')
							) {
								//console.log('checkV 4');
								checkValid(lengthParam, unitsParam);
							}
						} else {
							variationIdElem.value = '';
							disableAddToQuoteButton();
						}
						//SARAHHERE
						//console.log('enabling 1');
						enableAddToQuoteButton();
					} else {
						showError('No variations found.');
					}
				} catch (innerError) {
					console.log('ERror processing data: ', innerError);
				}
			} else {
				showError('a Failed to load variations.');
			}
		} catch (error) {
			hideSpinner();
			showError('b Failed to load variations. ', error);
		}
	}

	function showError(message) {
		console.log(message);
	}

	// Function to display quote drawer
	function displayQuoteDrawer(itemCount, quoteCart, shouldOpen) {
		let drawerContent = `<ul class="list-none pl-0">`;
		for (let key in quoteCart) {
			if (quoteCart.hasOwnProperty(key)) {
				let item = quoteCart[key];
				let width = '';
				let units2 = '';

				item.attr.forEach((attr) => {
					if (attr.label === 'width')
						width = attr.value.replace(/-/g, '.');
					if (attr.label === 'units2')
						units2 = getDisplayUnits(attr.value);
				});

				drawerContent += `
                    <li id="drawer-${item.key}" class="py-3">
                        <div class="card card-side rounded-none">
                            ${
								item.categories.categories[0].thumbnail_url
									? `<figure class="mt-1.5 min-w-[70px] min-h-[70px]"><img loading="lazy" class="w-[70px] h-[70px] rounded" src="${item.categories.categories[0].thumbnail_url}" alt="${item.categories.categories[0].sub_name}" /></figure>`
									: ''
							}
                            <div class="card-body py-0 pr-0">
                                <h4 class="my-0">${
									item.categories.categories[0].sub_name
								} ${item.categories.grade}</h4>
                                <div class="flex justify-between">
                                    <div class="text-sm lg:text-base">
                                        ${item.attr
											.filter(
												(attr) =>
													![
														'length',
														'material_cert',
														'width',
														'units2',
													].includes(attr.label)
											)
											.map((attr) => {
												return `${
													attr.label
												}: ${attr.value.replace(
													/-/g,
													'.'
												)}<br/>`;
											})
											.join('')}
											${width ? `Width: ${width} ${units2}<br/>` : ''}
											${units2 && !width ? `Width: Stock Width<br/>` : ''}
											${item.length != 0 ? `Length: ${item.length}` : `Length: `} ${getDisplayUnits(
					item.units_id
				)}<br/>



                                        ${
											item.material_certification === 1
												? 'Material Certification<br/>'
												: ''
										}
                                    </div>
                                    <div class="text-right text-sm lg:text-base">
                                        Qty: ${item.quantity}<br/>
                                        <a href="${
											item.key
										}" class="remove remove-cart-item remove-quote-item hover:text-secondary" aria-label="Remove this item" data-cart_item_key="${
					item.key
				}">Remove</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                `;
			}
		}
		drawerContent += `</ul>`;
		drawerContent += `<div class="block mb-4"><a href="/request-a-quote" class="btn btn-ghost w-full">View My Quote</a></div>`;
		drawerContent += `<div class="block mb-12"><a href="/" class="btn group w-full">
			<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-secondary fill-secondary group-hover:fill-white" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9.8s8.8 24.8-.8 33.9L83.9 232H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H83.9l132.7 126.6c9.6 9.2 9.9 24.3.8 33.9s-24.3 9.9-33.9.8l-176-168z"/></svg>
			Add Additional Items
		</a></div>`;
		document.getElementById(
			'insert-quote-content'
		).innerHTML = drawerContent;

		const spinner = createSpinner();

		if (shouldOpen) {
			quoteDrawer.classList.add('open');
			document.body.classList.add('overflow-hidden');
		}

		document
			.querySelector('.quote-drawer-close')
			.addEventListener('click', function () {
				quoteDrawer.classList.remove('open');
				document.body.classList.remove('overflow-hidden');
			});
	}

	function getDisplayUnits(unitsId) {
		//console.log('get units for ', unitsId);
		const unitsMap = {
			'stock-length': 'Stock Length',
			feet: 'Feet',
			inches: 'Inches',
			cwt: 'CWT',
			meters: 'Meters',
			millimeters: 'Millimeters',
		};
		return unitsMap[unitsId] || unitsId;
	}

	function createSpinner() {
		const spinner = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'svg'
		);
		spinner.setAttribute('class', 'animate-spin h-5 w-5 mr-3 spinner');
		spinner.setAttribute('viewBox', '0 0 24 24');
		spinner.innerHTML =
			'<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.963 7.963 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>';
		return spinner;
	}

	async function populateGradeAndEquivalents(
		equivalents,
		gradeToolTip,
		grade
	) {
		if (Object.entries(equivalents).length > 0) {
			//console.log(equivalents);
			const allEmpty = Object.values(equivalents).every(
				(arr) => arr.length === 1 && arr[0] === ''
			);
			if (allEmpty) {
			} else {
				enableCheckbox(document.getElementById('equiv'));
				for (const [key, value] of Object.entries(equivalents)) {
					const el = document.getElementById(key);

					if (
						Array.isArray(value) &&
						value.length > 0 &&
						value[0] != ''
					) {
						document.getElementById(key).innerHTML = value[0];
						if (el) {
							//console.log('el ', el);
							const allMe = document.querySelectorAll(
								'[data-id="' + key + '"]'
							);
							allMe.forEach((element) => {
								if (element.classList.contains('hidden')) {
									element.classList.remove('hidden');
									//console.log('show me');
								}
							});
						}
					} else {
						if (el) {
							//console.log('el ', el);
							const allMe = document.querySelectorAll(
								'[data-id="' + key + '"]'
							);
							allMe.forEach((element) => {
								if (!element.classList.contains('hidden')) {
									element.classList.add('hidden');
									//console.log('hide me');
								}
							});
						}
					}
				}
			}
		} else {
			disableCheckbox(document.getElementById('equiv'));
		}
		if (gradeToolTip != '') {
			const tooltipContent = `<p>
        <strong>Grade ${grade}</strong><br/>
        ${gradeToolTip}</p>
    `;

			const tooltipElement = document.getElementById('grade-tooltip');

			// Set the data attribute for the tooltip

			tooltipElement.innerHTML = tooltipContent;
		} else {
			document.getElementById('grade-tooltip').innerHTML =
				'<p>Please choose a metric metal grade</p>';
		}
	}

	var numberInputs = document.querySelectorAll(
		'#productDetails .number-input'
	);

	// Initialize from URL parameters
	function initializeFromURLParams() {
		const urlParams = new URLSearchParams(window.location.search);
		const grade = urlParams.get('grade');
		const paParams = Array.from(urlParams.entries()).filter(([key]) =>
			key.startsWith('pa_')
		);
		const paParamsObject = Object.fromEntries(paParams);
		Object.entries(paParamsObject).forEach(([key, value]) => {
			window['attribute_id-' + key] = value;
		});
		const length = urlParams.get('length');
		const units = urlParams.get('units');
		const certification = urlParams.get('certification');

		const width = urlParams.get('width');
		const units2 = urlParams.get('units2');

		if (grade) {
			setSelectValue(gradeSelect, gradeInput, grade).then((productId) => {
				productIdInput.value = productId;
				fetchProductDetails(productId, attributeSelectIds[0]);
				disableAddToQuoteButton();
			});
		}

		function checkInputValue() {
			if (lengthInput.value.trim() !== '') {
				//console.log('lgth check input');
				const url = new URL(window.location);
				url.searchParams.set('length', lengthInput.value);
				if (unitsArea.classList.contains('disabled')) {
					//console.log('unitsArea aa');
					unitsArea.classList.remove('disabled');
				}
				window.history.pushState({}, '', url);
				//enableAddToQuoteButton();
			}
		}
		if (lengthInput) {
			lengthInput.addEventListener('input', checkInputValue);
			checkInputValue();
		}
	}

	initializeFromURLParams();

	// Function to populate attribute select options
	function populateAttributeSelect(attributeSelect, attribute, productId) {
		//console.log('options ', attribute);
		const label = document.querySelector(
			'label[for="' + attributeSelect.id + '"]'
		);
		if (label) {
			label.classList.remove('disabled');
		}
		attributeSelect.removeAttribute('disabled');
		const selectId = attributeSelect.id;
		const selectElement = document.getElementById(selectId);
		let values = convertObjectToArrayDropKeys(attribute.options);
		// Sort the values numerically
		// Function to convert string to number, handling hyphenated format
		function stringToNumber(str) {
			// Replace hyphen with decimal point if present
			return parseFloat(str.replace('-', '.'));
		}

		// Sort the array
		values.sort((a, b) => {
			const numA = stringToNumber(a);
			const numB = stringToNumber(b);

			if (isNaN(numA) && isNaN(numB)) return 0;
			if (isNaN(numA)) return 1;
			if (isNaN(numB)) return -1;

			return numA - numB;
		});

		const selectIndex = selectElement.getAttribute('data-index');
		const attrName = selectId.replace('attribute_id-', '');

		let options = values
			.map(
				(value) =>
					`<option value="${value}">${value.replace(
						'-',
						'.'
					)}</option>`
			)
			.join('');
		selectElement.innerHTML =
			'<option value="">Select a ' +
			attribute.label.toLowerCase() +
			'</option>' +
			options;
		if (window.hasOwnProperty(selectId)) {
			let inputId = attributeSelect.id.replace('attribute_id-', '');
			const inputEl = document.getElementById(inputId + '_id');
			setSelectValue(selectElement, inputEl, window[selectId]).then(
				(productId) => {
					selectedAttributes[inputId] = window[selectId];
					let selectIndex = selectElement.getAttribute('data-index');
					updateVariationId(productId, numOfSelects, selectIndex);
				}
			);
		}
	}

	// Function to set select value
	function setSelectValue(select, selectInput, value) {
		return new Promise((resolve) => {
			select.value = value;
			selectInput.value = value;
			select.dispatchEvent(new Event('change'));
			jQuery(select).trigger('change');
			const selectedOption = select.options[select.selectedIndex];
			if (!productId) {
				productId = selectedOption.dataset.productid;
			}
			setTimeout(() => {
				resolve(productId);
			}, 0);
		});
	}

	function convertObjectToArrayDropKeys(variable) {
		if (
			variable &&
			typeof variable === 'object' &&
			!Array.isArray(variable)
		) {
			return Object.values(variable);
		}
		return variable;
	}

	async function updateQuoteCount(setOpen) {
		try {
			const response = await fetch(quote_params.ajax_url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams({
					action: 'get_quote_item_count',
					nonce: quote_params.nonce,
				}),
			});

			if (!response.ok) {
				throw new Error('Network response was not ok');
			}

			const data = await response.json();
			//console.log('quote number ', data);
			if (data.success) {
				const newQuoteCount = data.data.item_count;
				if (quoteCountDisplay) {
					if (newQuoteCount > 0) {
						quoteCountDisplay.forEach((el) => {
							el.textContent = newQuoteCount;
							if (!el.classList.contains('active')) {
								el.classList.add('active');
							}
						});
					} else {
						quoteCountDisplay.forEach((el) => {
							el.textContent = '';
							el.classList.remove('active');
						});
					}

					const quoteItems = data.data.quote_cart;
					displayQuoteDrawer(newQuoteCount, quoteItems, setOpen);
				}
			} else {
				console.error(data.data.message);
			}
		} catch (error) {
			console.error('Failed to update quote count:', error);
		}
	}

	// Initialize quote count on page load
	updateQuoteCount(false);
}); // end doc ready
